import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';

import ConfirmButton from '@ts-core/components/ConfirmButton';

import ForumItemToolbarButton from './ForumItemToolbarButton';
import ReportForumItemButton from './ReportForumItemButton';

const useStyles = makeStyles((theme) => ({
  toolbarButton: {
    '&:not(:first-child)': {
      marginLeft: theme.spacing(2),
    },
  },
}));

const ForumItemToolbar = (props) => {
  const classes = useStyles();
  const {
    item,
    loading,
    className,
    onDeleteItem,
    onReportItem,
    onEditItem,

    canDelete,
    canReport,
    canEdit,

    contentType,
  } = props;

  const handleDeleteItem = useCallback(() => {
    onDeleteItem(item);
  }, [item, onDeleteItem]);

  const handleReportItem = useCallback(
    (message) => {
      onReportItem(item, { message });
    },
    [item, onReportItem]
  );

  const handleEditItem = useCallback(() => {
    onEditItem(item);
  }, [item, onEditItem]);

  return (
    <Box display="flex" py={2} className={className} justifyContent="flex-end">
      {loading ? (
        ''
      ) : (
        <>
          {canEdit && (
            <ForumItemToolbarButton
              className={classes.toolbarButton}
              Icon={Edit}
              title={
                <FormattedMessage
                  id="forum.button.editItem"
                  defaultMessage="Editar"
                />
              }
              onClick={handleEditItem}
            />
          )}
          {canReport && (
            <ReportForumItemButton
              className={classes.toolbarButton}
              onReportItem={handleReportItem}
              contentType={contentType}
            />
          )}
          {canDelete && (
            <ConfirmButton
              onConfirm={handleDeleteItem}
              alertTitle={
                <FormattedMessage
                  id="forum.alert.deleteItem.title"
                  defaultMessage="Eliminar"
                />
              }
              alertMessage={
                <FormattedMessage
                  id="forum.alert.deleteItem.message"
                  defaultMessage="¿Seguro que deseas eliminar este item permanentemente?"
                />
              }
            >
              {({ onClick }) => (
                <ForumItemToolbarButton
                  className={classes.toolbarButton}
                  Icon={Delete}
                  title={
                    <FormattedMessage
                      id="forum.button.deleteItem"
                      defaultMessage="Eliminar"
                    />
                  }
                  onClick={onClick}
                />
              )}
            </ConfirmButton>
          )}
        </>
      )}
    </Box>
  );
};

ForumItemToolbar.propTypes = {
  className: PropTypes.string,
  item: PropTypes.object,
  loading: PropTypes.bool,

  canDelete: PropTypes.bool,
  canReport: PropTypes.bool,
  canEdit: PropTypes.bool,

  onDeleteItem: PropTypes.func,
  onReportItem: PropTypes.func,
  onEditItem: PropTypes.func,

  contentType: PropTypes.oneOf(['post', 'answer']).isRequired,
};

ForumItemToolbar.defaultProps = {
  className: undefined,
  item: {},
  loading: false,

  canDelete: true,
  canReport: true,
  canEdit: true,

  onDeleteItem() {},
  onReportItem() {},
  onEditItem() {},
};

export default ForumItemToolbar;
